export default "__VITE_ASSET__3fc7e61e__"